// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuBase_menu__mNcml"};